import React, { useState } from 'react';
import UpdateTimesheetForm from './UpdateTimesheetForm';
import { useNavigate } from 'react-router-dom';
import CountdownTimer from '../core/helper/CountdownTimer';

const TimesheetNotSavedList = ({ timesheetData }) => {
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const navigate = useNavigate();

  const handleUpdateClick = (timesheet) => {
    setSelectedTimesheet(timesheet);
  };
  return (
    <div>
      <div style={{maxWidth:"400px"}}>
      <table className="table " >
        <thead>
          <tr >
            <th style={{fontSize:"11px",textAlign:"center"}}>Date</th>
            <th style={{fontSize:"11px",textAlign:"center"}}>Vessel</th>
            <th style={{fontSize:"11px",textAlign:"center"}}>Expires In</th>
            <th style={{fontSize:"11px",textAlign:"center"}}>Actions</th>

          </tr>
        </thead>
        <tbody>
          {timesheetData.map((timesheet) => {
          const createdTime = new Date(timesheet.timesheet_created_at).getTime();
          const deadline = createdTime + (24 * 60 * 60 * 1000);
          const isInitiallyExpired = new Date().getTime() > deadline;

          // IMPORTANT: Only allow update if not expired OR if admin has overridden (unblocked)
          const isLocked = isInitiallyExpired && !timesheet.is_ts_admin_unblocked;

          return (
            <tr key={timesheet.timesheet_id} style={{fontSize:"11px", textAlign:"center",verticalAlign:"middle"}}>
              <td>{timesheet.timesheet_date}</td>
              <td>{timesheet.timesheet_vessel_name}</td>
              <td>
                <CountdownTimer 
                  createdAt={timesheet.timesheet_created_at} 
                  onExpire={() => {/* Optional: trigger a re-render if needed */}} 
                />
              </td>
              <td>
                <button
                  type="button"
                  className='btn2 mobile-compact-cell'
                  disabled={isLocked} // Disable button if time is up
                  style={{ 
                    opacity: isLocked ? 0.5 : 1, 
                    cursor: isLocked ? 'not-allowed' : 'pointer' 
                  }}
                  onClick={() => handleUpdateClick(timesheet)}
                >
                  {isLocked ? "Locked" : "Update"}
                </button>
              </td>
            </tr>
          );
        })}
        
          {/* {timesheetData.map((timesheet) => (
            console.log("timesheet:", timesheet),
            <tr style={{fontSize:"11px"}} key={timesheet.timesheet_id}>
              <td style={{fontSize:"11px",textAlign:"center"}}>{timesheet.timesheet_date}</td>
              <td style={{fontSize:"11px",textAlign:"center"}}>{timesheet.timesheet_vessel_name}</td>
              <td >
                <button
                  type="button"
                  className="btn2 mobile-compact-cell"
                  style={{fontSize:"11px",textAlign:"center"}}
                  onClick={() => handleUpdateClick(timesheet)}
                >
                  Update
                </button>
              </td>
              <td></td>
            </tr>
          ))} */}
        </tbody>
      </table>
      </div>
      {selectedTimesheet && (
        <UpdateTimesheetForm
          timesheet={selectedTimesheet}
          onUpdate={() => navigate('/user/dashboard')}
          onClosePopup={() => setSelectedTimesheet(null) }
        />
      )}
    </div>
  );
};

export default TimesheetNotSavedList;






